import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

import { hasObjectKeys } from 'utils/main';
import InsideLoader from 'components/common/InsideLoader';
import Icons from 'consts/icons';
import {
  parseWeatherString,
  windDegreesParser,
} from 'components/uavos/utils/common';
import { formStyles } from 'consts/styles/Form';
import useStyles from './DetailsCardUseStyles';

const WeatherDetails = props => {
  const { weatherLoaded, weather, subtitles, weatherTitles } = props;
  const classes = useStyles();
  const formClasses = formStyles();

  return weatherLoaded && hasObjectKeys(weather) ? (
    <>
      <Grid
        item
        xs={12}
        className={`${formClasses.Form}__text-field__subtitle ${formClasses.Form}__text-field`}
      >
        <span>{`${subtitles.weather_} ${weather.name}`}</span>
      </Grid>
      <Grid className={`${classes.DetailsCard}__weather__content`}>
        <Grid item xs={3}>
          <span className={`${classes.DetailsCard}__weather__content__desc`}>
            <Tooltip placement="left" title={`${subtitles.temperature_}`}>
              <div
                className={`${classes.DetailsCard}__weather__content__desc__container`}
              >
                <Icons.Weather.Thermometer
                  className={`${classes.DetailsCard}__weather__content__desc__container__svg`}
                />
                {`${weather.main.temp}`}
                &#8451; {`/ ${weather.main.feels_like}`} &#8451;
              </div>
            </Tooltip>
          </span>
        </Grid>
        <Grid item xs={6}>
          <span className={`${classes.DetailsCard}__weather__content__desc`}>
            <Tooltip placement="left" title={`${subtitles.wind_}`}>
              <div
                className={`${classes.DetailsCard}__weather__content__desc__container`}
              >
                <Icons.Weather.WindStrong
                  className={`${classes.DetailsCard}__weather__content__desc__container__svg`}
                />
                {`${weather.wind.speed} m/s / ${
                  subtitles.windParser[`${windDegreesParser(weather.wind.deg)}`]
                }`}{' '}
                &#176;
              </div>
            </Tooltip>
          </span>
        </Grid>
        <Grid
          item
          xs={3}
          className={`${classes.DetailsCard}__weather__content__conditions`}
        >
          <span className={`${classes.DetailsCard}__weather__content__desc`}>
            {' '}
            <Tooltip placement="left" title={`${subtitles.weatherCondition_}`}>
              <div
                className={`${classes.DetailsCard}__weather__content__desc__container`}
              >
                <img
                  alt="weather-icon"
                  width={40}
                  height={40}
                  src={`https://openweathermap.org/img/wn/${weather.weather[0].icon}@2x.png`}
                />
                <span>
                  {
                    weatherTitles[
                      parseWeatherString(weather.weather[0].description)
                    ]
                  }
                </span>
              </div>
            </Tooltip>
          </span>
        </Grid>
      </Grid>
    </>
  ) : (
    <div className={`${classes.DetailsCard}__loader`}>
      {!weatherLoaded ? (
        <InsideLoader
          loaderSize={20}
          text={subtitles.loadingWeather_}
          fontSize={12}
        />
      ) : (
        <Typography align="center" color="primary">
          {subtitles.noWeatherData_}
        </Typography>
      )}
    </div>
  );
};

export default WeatherDetails;

WeatherDetails.propTypes = {
  weatherLoaded: PropTypes.bool.isRequired,
  weather: PropTypes.object.isRequired,
  subtitles: PropTypes.object.isRequired,
  weatherTitles: PropTypes.object.isRequired,
};
